const SAFE_PROTOCOLS = new Set(['http:', 'https:', 'mailto:'])

const MODULIFY_CDN_SUFFIX = '.cdn.modulify.website'

// Turns a link typed into the CMS into something safe to put in an href.
// "instagram.com/name" becomes "https://instagram.com/name"; anything that is
// not a web, or mailto, address (such as javascript:) is dropped.
export const normalizeLink = (value: string | null | undefined): string | null => {
    const trimmed = value?.trim()

    if (!trimmed) return null

    const candidate = /^[a-z][a-z\d+.-]*:/i.test(trimmed) ? trimmed : `https://${trimmed.replace(/^\/+/, '')}`

    try {
        const url = new URL(candidate)

        return SAFE_PROTOCOLS.has(url.protocol) ? url.toString() : null
    }
    catch {
        return null
    }
}

// Server-only. The CDN address follows the site's subdomain, so a file saved with
// an older address is pointed at the current one (CDN_URL) when the page is built.
export const resolveAssetUrl = (value: string | null | undefined): string | null => {
    const trimmed = value?.trim()

    if (!trimmed) return null

    const current = process.env.CDN_URL

    if (!current) return trimmed

    try {
        const asset = new URL(trimmed)
        const base = new URL(current)

        if (!asset.hostname.endsWith(MODULIFY_CDN_SUFFIX) || asset.hostname === base.hostname) return trimmed

        return `${base.origin}${asset.pathname}${asset.search}`
    }
    catch {
        return trimmed
    }
}

export const isExternalLink = (href: string): boolean => /^https?:\/\//i.test(href)
